import React from 'react';
import Heading from '../../../components/controls/Typography/Heading';
import useRecommendation from '../../../utils/useRecommendation';

export const ObservationHoursTable = () => {
  const recommendation = useRecommendation();
  const observationHoursDataEval = recommendation.item?.observationHoursDataEval;

  const { hoursCompleted, hoursPlanned } = [
    ...(observationHoursDataEval?.inPatientSettings ?? []),
    ...(observationHoursDataEval?.outPatientSettings ?? []),
    ...(observationHoursDataEval?.otherSettings ?? []),
  ].reduce((r, v) => ({
    hoursCompleted: r.hoursCompleted + v.hoursCompleted,
    hoursPlanned: r.hoursPlanned + v.hoursPlanned
  }), { hoursPlanned: 0, hoursCompleted: 0 });

  return (
    <div className="lsn-observation-group lsn-observation-table">
      <Heading bold level={3} tabIndex={0} asSpan className="lsn-obs-recommendation-form-header lsn-observation-tbl-title">Observation Hours</Heading>
      <table className="table table-striped table-hover lsn-obs-table">
        <thead>
          <tr>
            <th className="lsn-obs-table-first-column">
              <b>Inpatient</b> (Facility generally admits patients overnight)
            </th>
            <th>
              <b>Hours Completed</b>
            </th>
            <th>
              <b>Hours Planned/In Progress</b>
            </th>
          </tr>
        </thead>
        <tbody>
          {observationHoursDataEval?.inPatientSettings
            ? observationHoursDataEval.inPatientSettings.map((patient, idx) => (
              <tr className="active" key={idx}>
                <td>{patient.label}</td>
                <td className="lsn-obs-table-td">{patient.hoursCompleted}</td>
                <td className="lsn-obs-table-td">{patient.hoursPlanned}</td>
              </tr>
            ))
            : []}
        </tbody>
      </table>
      <table className="table table-striped table-hover lsn-obs-table">
        <thead>
          <tr>
            <th className="lsn-obs-table-first-column">
              <b>Outpatient</b> (Facility has no overnight patients)
            </th>
            <th>
              <b>Hours Completed</b>
            </th>
            <th>
              <b>Hours Planned/In Progress</b>
            </th>
          </tr>
        </thead>
        <tbody>
          {observationHoursDataEval?.outPatientSettings
            ? observationHoursDataEval.outPatientSettings.map((patient, idx) => (
              <tr className="active" key={idx}>
                <td>{patient.label}</td>
                <td className="lsn-obs-table-td">{patient.hoursCompleted}</td>
                <td className="lsn-obs-table-td">{patient.hoursPlanned}</td>
              </tr>
            ))
            : []}
        </tbody>
      </table>

      {observationHoursDataEval?.otherSettings && (
        <table className="table table-striped table-hover lsn-obs-table">
          <thead>
            <tr>
              <th className="lsn-obs-table-first-column">
                <b>Other Settings</b> (Non-clinical settings)
              </th>
              <th>
                <b>Hours Completed</b>
              </th>
              <th>
                <b>Hours Planned/In Progress</b>
              </th>
            </tr>
          </thead>
          <tbody>
            {observationHoursDataEval?.otherSettings
              ? observationHoursDataEval.otherSettings.map((otherSetting, idx) => (
                <tr className="active" key={idx}>
                  <td>{otherSetting.label}</td>
                  <td className="lsn-obs-table-td">{otherSetting.hoursCompleted}</td>
                  <td className="lsn-obs-table-td">{otherSetting.hoursPlanned}</td>
                </tr>
              ))
              : []}
          </tbody>
        </table>
      )}

      <table className="table table-striped table-hover lsn-obs-total-table">
        <thead>
          <tr>
            <th className="lsn-obs-table-first-column">
              <b>Total Hours For all Settings</b>
            </th>
            <th className="lsn-obs-table-comp-col">
              {hoursCompleted}
            </th>
            <th className="lsn-obs-table-td">
              {hoursPlanned}
            </th>
          </tr>
        </thead>
      </table>
    </div>
  );
}

export default ObservationHoursTable;
